<template>
    <div class="bg">
        <img src="@/assets/home/bgLeft.png" alt="" class="bgLeft">
        <img src="@/assets/home/bgRight.png" alt="" class="bgRight">
        <div class="container animate__animated animate__fadeIn">
            <div class="contactUs">
                <div class="title">
                    CONTACT US
                    <h1>联系我们</h1>
                    <div>
                        <i></i> <i></i>
                    </div>
                </div>
                <div class="main">
                    <div class="image animate__animated animate__fadeInLeft">
                        <img src="@/assets/about/tel.png" alt="">
                    </div>
                    <div class="text animate__animated animate__fadeInRight">
                        <div class="info-item">
                            <img src="@/assets/linker.png" alt="联系人">
                            <p>联系人：丁先生</p>
                        </div>
<!--                        <div class="info-item">-->
<!--                            <img src="@/assets/phone2.png" alt="手机">-->
<!--                            <p>手机：18951981008</p>-->
<!--                        </div>-->
                        <div class="info-item">
                            <img src="@/assets/phone1.png" alt="固话">
                            <p>固话：025-57660015</p>
                        </div>
                        <div class="info-item">
                            <img src="@/assets/position1.png" alt="地址">
                            <p>地址：南京市王桥路57号六合科创中心B座2F</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContactUs",
    mounted() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
}
</script>

<style scoped lang="less">
.bg {
    width: 100%;
    min-height: 100vh;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;

    .bgLeft, .bgRight {
        width: 50%;
        position: absolute;
        pointer-events: none;
    }

    .bgLeft {
        left: 0;
        bottom: 0;
    }

    .bgRight {
        right: 0;
        top: 0;
    }
}

.container {
    max-width: 1280px;
    margin: 0 auto;
    padding: 212px 0 145px;
    position: relative;
    z-index: 1;
}

.title {
    text-align: left;
    margin-bottom: 60px;

    h1 {
        font-size: 30px;
        font-weight: 900;
        color: #3C5289;
        margin: 0;
        position: relative;
        z-index: 2;
    }

    &::before {
        content: 'CONTACT US';
        position: absolute;
        font-size: 90px;
        font-weight: bold;
        color: rgba(60, 82, 137, 0.1);
        top: -40px;
        left: 0;
        z-index: 1;
    }

    div {
        display: flex;
        margin-top: 15px;

        i {
            display: block;
            height: 6px;
            background: #3C5289;

            &:first-child {
                width: 30px;
                margin-right: 4px;
            }

            &:last-child {
                width: 5px;
            }
        }
    }
}

.main {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 80px;

    .image {
        flex: 1;
        max-width: 600px;

        img {
            width: 100%;
            height: auto;
        }
    }

    .text {
        flex: 1;
        max-width: 600px;

        .info-item {
            display: flex;
            align-items: center;
            margin-bottom: 40px;

            &:last-child {
                margin-bottom: 0;
            }

            img {
                width: 34px;
                height: 34px;
                margin-right: 15px;
            }

            p {
                margin: 0;
                font-size: 20px;
                font-weight: 600;
                color: #333;
            }
        }

        // 黑色图标
        .info-item:nth-child(-n+2) img {
            filter: brightness(0);
        }
    }
}

@media (max-width: 1000px) {
    .container {
        padding: 80px 20px 60px;
    }

    .title {
        margin-bottom: 40px;

        h1 {
            font-size: 24px;
        }

        &::before {
            font-size: 40px;
            top: -20px;
        }

        div i {
            height: 4px;

            &:first-child {
                width: 20px;
            }

            &:last-child {
                width: 3px;
            }
        }
    }

    .main {
        flex-direction: column;
        gap: 40px;

        .image {
            max-width: 100%;
        }

        .text {
            max-width: 100%;

            .info-item {
                margin-bottom: 25px;

                img {
                    width: 24px;
                    height: 24px;
                    margin-right: 10px;
                }

                p {
                    font-size: 16px;
                }
            }
        }
    }
}
</style>
